/**
 * @prettier
 */

import React from 'react';
import SamplePreview from '../SamplePreview/SamplePreview';
import Layout from '../Layout/Layout';
import { STEPS } from '../constants/steps';

import styles from './styles.module.less';

const SamplePreviewStage = ({
  form,
  goToStep,
  updateForm,
  colors,
  sampleNotCustomizable,
  template,
  isGuest,
  skuData,
  cardSuiteDetails,
  isMagnet,
}) => {
  return (
    <div className={styles.samplePreviewStageOuterBox}>
      <div className={styles.samplePreviewStageInnerBox}>
        <Layout.Header>Preview Your Sample</Layout.Header>
        {isMagnet && <Layout.Text>Magnets are 4.25 x 5.5 in</Layout.Text>}
        <SamplePreview
          hideColorPicker={sampleNotCustomizable}
          colors={colors}
          template={template}
          form={form}
          updateForm={updateForm}
          sampleNotCustomizable={sampleNotCustomizable}
          skuData={skuData}
          cardSuiteDetails={cardSuiteDetails}
          isMagnet={isMagnet}
        />
        <div className={styles.previewStageFormButtonBox}>
          <Layout.FormButtons
            backLabel="Back"
            nextLabel="Submit Order"
            onBack={() =>
              goToStep(isGuest ? STEPS.ACCOUNT_DETAILS_FORM : STEPS.SHIPPING_DETAILS_FORM)
            }
            onNext={() => goToStep(STEPS.FLOW_COMPLETION)}
          />
        </div>
      </div>
    </div>
  );
};

export default SamplePreviewStage;



// WEBPACK FOOTER //
// ./src/cards/components/common/SingleSample/SingleSampleFlowSteps/SamplePreviewStage.jsx